export default {
	"users_register": {
        "registerPhone": "Register by phone number",
        "registerEmail": "Register by email",
        "hasAccount": "Already got an account?",
        "agree": "I Agree",
        "agreement": "Glocalme User Agreement",
        "and": "and",
        "policy": "Privacy policy",
        "logoutNotice": "Account delete permanently",
        "submit": "Submit",
        "selectArea": "Select residence",
        "countryOrRegion": "Country/Region",
        "change": "Change",
        "defaultRegion": "Mainland China",
        "AE": "United Arab Emirates",
        "search": "Top searching countries/regions",
        "reminder": "Reminder",
        "reminderTips": "Select【",
        "reminderTips2": "】 as your residential location for exclusive benefits. It cannot be changed in future, are you sure?",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "setPassword": "Set the password",
        "registerByEmail": "Click the link to complete your registration",
        "activeSuc": "Activated successfully",
	    "activeing": "Activating",
        "activeAgain": "Activate again",
        "activeFail": "Activation Failed",
        "verified": "I have verified",
        "registerSuccess": "Registration success"
    },
    "users_login": {
        "loginPhone": "Login via phone number",
        "loginEmail": "Login via email",
        "register": "Register an account",
        "inputPhone": "Input the phone number",
        "inputPassword": "Input the password",
        "forgetPassword": "Forgot password",
        "login": "Login",
        "goToLogin": "Login now",
        "inputEmail": "Input the email",
        "smsCode": "SMS verification code",
        "inputSMSCode": "Input the SMS verification code",
        "noReceiveCode": "cannot received the code?",
        "resend": "Resend",
        "nextStep": "Next Step",
        "findByPhone": "Recover password by phone number",
        "findByEmail": "Recover password by email",
        "verifyByEmail": "Go to mailbox for verification",
        "sendEmailTo": "Email has been sent to",
        "findYourPassword": "Please click the attached link and follow the steps to recover your password.",
        "noReceiveEmail": "Cannot receive the email? Please check your junk or deleted folder for any messages from glocalme@ucloudlink.com",
        "or": "or",
        "resetPassword": "Reset password",
        "oldFormat": "at least 6 characters",
        "passwordFormat": "6-20 characters (a combination of letters, numbers or symbols)",
        "completeLogin": "Completed and Login",
        "resetPasswordSuc": "Reset password successfully",
        "backToGlocalMe": "Go to GlocalMe Connect for continue",
        "activeReminder": "The account hasn't been activated, please go to your mailbox to complete your register via the activation link",
        "known": "I understand"
    },
    "modify_information": {
        "account": "Account",
        "name": "Name",
        "identification": "Passport or ID No.",
        "countryName": "Residence",
        "id": "Identity Information",
        "edit": "Edit",
        "complete": "Completed",
        "placeholderFirstName": "Input your last name",
        "placeholderName": "Input your first name",
        "firstName": "Last Name",
        "lastName": "First Name",
        "placeholderID": "Input your ID No. / Visa No. / car plate No.",
        "isNull": "unfilled",
        "onlyNumber": "Numbers or letters only",
        "IDTip": "Numbers or letters only"
    },
    "route.email":"Register by email",
    "route.mobilephone":"Register by phone number",
    "register.Rplace":"Please select the registration place",
    "register.Uagreement":"Please agree to the user agreement",
    "register.UnhaveAccount":"Account not Entered",
    "register.AccountError":"Incorrect account format",
    "register.RegisterChannel":"Registration channel",
}


// WEBPACK FOOTER //
// ./src/lang/jp/register.js